/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as vscode from 'vscode';
import { $Knc } from './client/client';
import { $gnc } from './commandManager';
import { $poc } from './commands/index';
import { $qoc } from './languageFeatures/copyFiles/copyPaste';
import { $roc } from './languageFeatures/copyFiles/copyPasteLinks';
import { $soc } from './languageFeatures/diagnostics';
import { $toc } from './languageFeatures/copyFiles/dropIntoEditor';
import { $woc } from './languageFeatures/fileReferences';
import { $zoc } from './languageFeatures/linkUpdater';
import { ILogger } from './logging';
import { $rnc } from './markdownEngine';
import { MarkdownContributionProvider } from './markdownExtensions';
import { $Tnc } from './preview/documentRenderer';
import { $4nc } from './preview/previewManager';
import { $Rnc } from './preview/security';
import { $5nc } from './telemetryReporter';
import { $Mnc } from './util/openDocumentLink';

export function $Aoc(
	context: vscode.ExtensionContext,
	client: $Knc,
	engine: $rnc,
	logger: ILogger,
	contributions: MarkdownContributionProvider,
) {
	const telemetryReporter = $5nc();
	context.subscriptions.push(telemetryReporter);

	const cspArbiter = new $Rnc(context.globalState, context.workspaceState);
	const commandManager = new $gnc();

	const opener = new $Mnc(client);

	const contentProvider = new $Tnc(engine, context, cspArbiter, contributions, logger);
	const previewManager = new $4nc(contentProvider, logger, contributions, opener);
	context.subscriptions.push(previewManager);

	context.subscriptions.push(registerMarkdownLanguageFeatures(client, commandManager));
	context.subscriptions.push($poc(commandManager, previewManager, telemetryReporter, cspArbiter, engine));

	context.subscriptions.push(vscode.workspace.onDidChangeConfiguration(() => {
		previewManager.updateConfiguration();
	}));
}

function registerMarkdownLanguageFeatures(
	client: $Knc,
	commandManager: $gnc,
): vscode.Disposable {
	const selector: vscode.DocumentSelector = { language: 'markdown', scheme: '*' };
	return vscode.Disposable.from(
		// Language features
		$soc(selector, commandManager),
		$toc(selector),
		$woc(commandManager, client),
		$qoc(selector),
		$roc(selector),
		$zoc(client),
	);
}

